module.exports = __webpack_public_path__ + "img/home-icon-5.acdce25c.png";